export const frontStyleLvzSelector = ({frontStyleLvz}) => frontStyleLvz